export const diccionario_en = {
  hola: "Hello",
  Leida: "Read",
  Archivada: "Archived",
  empleados: "Employees",
  BloquearReserva: "Block Reservation",
  empleado: "Employee",
  empezar: "start",
  empezada: "started",
  organizacion: "Organization",
  estructura: "Structure",
  organizativa: "organizational",
  crear: "Create",
  visualizar: "Visualize",
  modificar: "Modify",
  listados: "Listings",
  listado: "Listing",
  recursos: "Human Resources",
  resumen: "Summary",
  evaluados: "Evaluated",
  evaluado: "Evaluated",
  evaluaciones: "Evaluations",
  evaluacion: "Evaluation",
  evaluada: "Evaluated",
  pruebas: "Tests",
  areas: "Areas",
  evainiciadas: "Eva. started",
  abstencion: "Abstention",
  evarealizadas: "Eva. completed",
  ranking: "Employee ranking by evaluation",
  nombre: "Name",
  Nombre: "Name",
  apellidos: "Surnames",
  area: "Area",
  estado: "Status",
  fecha: "Date",
  resultado: "Result",
  todas: "All",
  año: "year",
  competencias: "competences",
  destacadas: "outstanding",
  buenas: "good",
  normales: "normal",
  alejadas: "distant",
  submitida: "submitted",
  submitidas: "submitted",
  submitir: "submit",
  completas: "complete",
  periodos: "Periods",
  fomulario: "Form",
  actualizar: "Update",
  busqueda: "Search fields",
  rellenar: "Fill in a field with the value of the employee you wish to retrieve",
  rellenar2: "Fill in a field with the value of the structure you wish to retrieve",
  limpiarcampos: "Clear fields",
  seleccionado: "selected",
  hombre: "Man",
  mujer: "Woman",
  otros: "Other",
  genero: "Gender",
  cargo: "Position",
  acceso: "Access",
  herramienta: "tool",
  registro: "record",
  telefono: "Phone",
  inicio: "start",
  Bueno: "Good",
  Destacado: "Outstanding",
  Alejado: "Distant",
  Normal: "Normal",
  sin: "Without",
  finalizar: "finish",
  aviso0: "You must at least answer some question of the questionnaire to start the evaluation",
  aviso1: "In order to finish the evaluation you must answer all the questions",
  aviso2: "To submit the evaluation you must activate the 'Submit' button",
  aviso3: "EVALUATION SUBMITTED, for any modification please contact the administrator",
  gerente: "Manager",
  observaciones: "Observations",
  aviso4: "Do you want to reopen the evaluation?",
  aviso5: "Do you want to submit the evaluation? Once submitted you will not be able to modify it",
  deLaOrganizacion: "OF THE ORGANIZATION (CORE)",
  PERSONALES: "PERSONAL",
  delPuesto: "OF THE POSITION",
  funcionales: "(FUNCTIONAL)",
  INTERPERSONALES: "INTERPERSONAL",
  delPuestoFuncionales: "OF THE POSITION (FUNCTIONAL)",
  Email: "Email",
  Fecha_Creacion: "Creation date",
  Id: "Identifier",
  SOSBloqueo: "SOS",
  Codigo_seguridad: "Security code (max 5 digits)",
  Codigo_vecino: "Community registration code",
  Cp: "Postal Code",
  Poblacion: "Town/City",
  Seguro_nombre: "Insurance Company",
  tooltip: "Insurance company associated with the Community",
  Poliza: "Policy",
  IBAN: "IBAN Account",
  Vecinos: "No. Neighbors",
  Pago_App: "Monthly APP Payment",
  Cif: "CIF",
  tip_comunidad: "Insurance company associated with the Community",
  listaComunidades: "List of communities",
  Direccion: "Address",
  Provincia: "Province",
  estadoComunidad: "Status",
  Altac365: "c365 Registration",
  AltaC3652: "Registration",
  Fecha_Baja: "Unsubscribe date",
  Bloqueada: "Blocked",
  tip_Bloqueada: "Click to block/unblock user access to the app",
  tip_Alta: "Activate/Contract community 365",
  tip_Baja: "Deactivate/Unsubscribe community 365 or see contract details",
  tituloBloquear: "Block community",
  tituloDesBloquear: "Unblock community",
  cuerpoBloquear: "Press accept to confirm the blocking of the community",
  cuerpoDesBloquear: "Press accept to confirm the unblocking of the community",
  tip_EnvioComunidades: "Send notices to the previously selected communities",
  ENVIAR_AVISO: "Send notice",
  ENVIAR_AVISO_DOCUMENTOS: "Send document notice",
  Buscar: "Search",
  Buscador: "Search Engine",
  Inicio: "Home",
  Comunidades: "Communities",
  Incidencias: "Incidents",
  Gremios: "Providers",
  Roles: "Roles",
  Notificaciones: "Notifications",
  Despacho: "Office",
  Documentos: "Documents",
  Usuarios: "Users",
  DescripcionMenuInicial: "Initial Menu Description",
  CIF: "CIF",
  Administracion: "Administration",
  AvisoLegal: "Legal Notice",
  PoliticaPrivacidad: "Privacy Policy",
  PoliticaCookies: "Cookies Policy",
  DescComunidades: "Management of communities",
  DescIncidencias: "Management of incidents",
  DescGremios: "Management of providers",
  DescRoles: "Management of roles",
  DescUsuarios: "Management of users",
  DescNotificaciones: "Management of Notifications",
  DescAdministracion: "Management of office",
  Juntas: "Meetings",
  Votaciones: "Votes",
  VotacionesOrdenDia: "Agenda/Votes",
  ZonasComunes: "Common Areas",
  Documentacion: "Documentation",
  Actividades: "Activities",
  Actividad: "Activity",
  DescJuntas: "Management of Meetings",
  DescVotaciones: "Management of Votes",
  DescZonasComunes: "Management of Common Areas",
  DescDocumentacion: "Management of Documentation",
  DescActividades: "Management of Activities",
  Detalle: "Detail",
  Mostrando: "Showing",
  a: "to",
  de: "of",
  resultados: "results",
  HasSeleccionado: "You have selected",
  comunidades: "communities",
  paraAviso: "for sending a NOTICE",
  comunidad: "community",
  Comunidad: "Community",
  exportarPdf: "Export to PDF",
  exportarCsv: "Export to CSV",
  filasPagina: "Rows per page",
  comunidadesSeleccionadas: "community/ies selected for notice.",
  CERRAR: "CLOSE",
  Restaurar: "Restore",
  tituloFormAvisos: "Send notices",
  asunto: "Subject",
  textoAviso: "Notice text",
  URLopcional: "Optional URL",
  diagoloTitulo: "Unsubscribe community",
  diagoloBody: "Are you sure you want to unsubscribe the community?",
  cerrar: "Close",
  guardarCambios: "Save changes",
  diagoloBodyAviso: "Are you sure you want to send the notice?",
  diagoloTituloAviso: "Send notice",
  Guardar: "Save",
  CNAE: "CNAE",
  TlfnPrincipal: "Phone (If there is more than one, they must be separated by commas)",
  TlfnSecundario: "Secondary phone",
  Email1: "Email (If there is more than one, they must be separated by commas)",
  Email2: "Email 2",
  idProveedor: "Provider Id",
  idComunidad: "Community Id",
  fechaInicioContrato: "Contract start date",
  fechaFinContrato: "Contract end date",
  observaciones: "Observations",
  sinresultados: "No results were found.",
  cancelar: "Cancel",
  aceptar: "Accept",
  Grupos: "Groups",
  AccesoATodo: "Access to everything",
  Documentacion: "Documentation",
  ZonasReserva: "Reservation zones",
  JuntasYVotaciones: "Meetings and votes",
  Observaciones: "Observations",
  Opciones: "Options",
  Acciones: "Actions",
  tip_BorrarRol: "Click to delete a role",
  confirmarBorradoRol: "You have marked a role to unsubscribe, do you want to continue?",
  tituloConfirmarBorradoRol: "Confirm deletion",
  Anadir: "Add",
  Proveedores: "Providers",
  SoloPara: "Only for:",
  Roles: "Roles",
  Numero: "Number",
  Portal: "Portal",
  Escalera: "Stairway",
  Piso: "Floor",
  Letra: "Letter",
  Inquilino: "Tenant",
  Multipropiedad: "Timeshare",
  Bloqueado: "Blocked",
  Bloq: "Block.",
  Usuario: "User",
  AdministradorFincaColegiado: "Collegiate Property Administrator",
  EmpleadoOficina: "Office Employee",
  RegistroHorario: "Clockings",
  Ano: "Year",
  SeleccionaAno: "Select a year",
  Entrada: "Entry",
  Salida: "Exit",
  Centro: "Center",
  Horas: "Hours",
  Semana: "Week",
  Fecha: "Date",
  TotalHoras: "Total Hours",
  Minutos: "Minutes",
  Modificar: "Modify",
  Eliminar: "Delete",
  Filtrar: "Filter",
  tituloNuevoRegistroHorario: "New time record",
  confirmarBorradoRegistroHorario: "Do you want to delete the time record?",
  tituloConfirmarBorradoRistroHorario: "Delete time record",
  EnviarCheckEmail: "Send verification Emails",
  tituloModificarRegistroHorario: "Modify time record",
  MiCarpeta: "My Folder",
  ReseteoContrasena: "Password Reset",
  TextoReseteoContrasena:
    "The user's password will be reset, at the moment the update is made the user must access the application with the new password",
  AnadeContrasena: "Add the new password (At least 6 digits)",
  Borrar: "Delete",
  Todo: "All",
  Reservas: "Reservations",
  ReservasDe: "Free reservations of",
  Despachos: "Offices",
  hasCambiadoDespacho: "You are now in the office",
  enviarAviso: "Send Notice",
  DNI: "ID",
  descripcion: "Description",
  tipo: "Type",
  EliminarUsuario: "Delete User",
  ConfirmarEliminarUsuario: "Do you want to delete the user?",
  DetalleActividad: "Activity details",
  AnadirActividad: "Add activity",
  tip_BorrarActividad: "Click to delete an activity",
  confirmarBorradoActividad:
    "You have marked an activity to unsubscribe, it will disappear from all your communities, do you want to continue?",
  tituloConfirmarBorradoActividad: "Confirm deletion",
  AnadirRol: "Add Role",
  confirmarBorradoVoto: "You have marked a vote to delete, do you want to continue?",
  tituloConfirmarBorradoVoto: "Confirm deletion",
  Icono: "Icon",
  Si: "Yes",
  No: "No",
  cuerpoDesBloquearUsuario: "Do you want to unblock the user",
  tituloDesBloquearUsuario: "Unblock user",
  cuerpoBloquearUsuario: "Do you want to block the user",
  tituloBloquearUsuario: "Block user",
  Porcentaje: "Percentage",
  Proveedor: "Provider",
  SeleccionaProveedor: "Search and select a provider...",
  UsuariosRegistradores: "Registering users",
  FalloPago: "The payment has failed, please try again later.",
  Gobierno: "Governing board",
  Administración: "Administration",
  Mantenimiento: "Maintenance",
  tituloEnvioCorrecto: "Sending result",
  mensajeResultados: "Notice sent correctly to ${var1} recipients",
  tip_BorrarGremio: "Click to delete a provider",
  confirmarBorradoGremio: "You have marked a provider to unsubscribe, do you want to continue?",
  tituloConfirmarBorradoGremio: "Confirm deletion",
  preciosSinIva: "All prices are without VAT.",
  preciosPorVecino:
    "Prices vary depending on the number of neighbors in the community. (This community has ${var1} neighbors)",
  preciosPorVecinoHistorico:
    "Prices vary depending on the number of neighbors in the community. (This community had ${var1} neighbors at the time of contracting)",
  CreadoPor: "Created by",
  estadoContrato: "Status",
  asociarActividad: "The activity will now appear on the mobile of the community users.",
  desasociarActividad: "The activity will no longer appear on the mobile of the community users.",
  asociarTodasActividades: "Now all activities will appear on the mobile of the community users",
  desasociarTodasActividades: "Now no activity will appear on the mobile of the community users",
  EnvioAvisoEmail: "In addition to the notice, also send by email to those involved",
  Codigo: "Code",
  Tipo: "Type",
  Actividad: "Activity",
  Registrador: "Registered by",
  // Registrador: "Registrador",
  tip_BorrarIncidencias: "Click to delete the incident",
  tip_BorrarNotificaciones: "Click to delete the notification",
  notificacionBorrada: "Notification deleted",
  tip_BorrarVotacion: "Click to delete the vote",
  tip_compartirIncidencia: "Share/publish the incident",
  tip_ModificarRegistroHorario: "Click to edit the record",
  tip_BorrarRegistroHorario: "Click to delete the record",
  tip_BorrarReserva: "Click to cancel the reservation",
  tituloCriticos: "Critical data has been changed!",
  bodyCriticos:
    "The fees will be returned to the users and future reservations will be deleted in order to save the configuration",
  Compartir: "Share",
  red: "Red",
  yellow: "Yellow",
  green: "Green",
  incidenciaGreen: "Incident closed or canceled",
  incidenciaYellow: "Incident in progress",
  incidenciaRed: "Incident not closed for 8 or more days",
  incidenciaRed2: "Open incident",
  ENVIAR_AVISO_EMAIL: "Send Registration Email",
  adminDesk: {},
  SeleccionaComunidad: "Select a community",
  SeleccionaEstado: "Select a status",
  SeleccionaActividad: "Select an activity",
  SeleccionaProveedor2: "Select a provider",
  Estado: "Status",
  ABIERTA: "OPEN",
  CERRADA: "CLOSED",
  CANCELADA: "CANCELED",
  ENCURSO: "IN PROGRESS",
  SeleccionaTipo: "Select type",
  INCIDENCIA: "BREAKDOWN",
  SINIESTRO: "ACCIDENT",
  SOLICITUD: "REQUEST",
  CONSULTA: "QUERY",
  AVISO: "NOTICE",
  SOS: "SOS",
  NuevaIncidencia: "New incident",
  DetalleIncidencia: "Incident details",
  DetalleVotacion: "Voting details",
  CodigoDespacho: "Office code",
  CodigoComunidad: "Community code",
  SeleccionaRegistrador: "Select a registrar",
  DescripcionIncidencia: "Incident description (visible to app users)",
  DatosGuardadosCorrectamente: "Data saved correctly.",
  ErrorGuardarDatos: "Error saving data.",
  mensajeDespublicarIncidencia:
    "By deactivating this option the incident will be private for the neighbors of the community.",
  mensajePublicarIncidencia:
    "By activating this option the incident will be public for all the neighbors of the community. Any modification and subsequent sending of a notice will be made to all registered owners.",
  Fecha_Modificacion: "Modification date",
  EmailProveedor: "Provider email",
  TelefonoProveedor: "Provider phone",
  ActualizaDescripcionInterna:
    "Internal notes of the incident (visible only to administrators and office employees)",
  HistoricoDescripcionInterna: "Incident history",
  HistoricoDescripcionInternaVota: "Vote history",
  TituloBorrarIncidencia: "Confirm incident deletion",
  CuerpoBorrarIncidencia: "To mark the incident as deleted press accept.",
  TituloCompartirIncidencia: "Confirm sharing incident",
  CuerpoCompartirIncidencia: "To share the incident press accept.",
  IncidenciaBorradaCorrectamente: "Incident deleted correctly",
  errorBorrarIncidencia: "Error deleting the incident",
  errorBorrarNotificacion: "Error deleting the notification",
  NotificacionBorradaCorrectamente: "Notification deleted correctly",
  IncidenciaCompartidaCorrectamente: "Incident shared correctly",
  errorCompartirIncidencia: "Error sharing the incident",
  incidenciaBorrada: "Incident deleted",
  votacionBorrada: "Vote deleted",
  notifiacionBorrada: "Notification deleted",
  incidenciaCompartida: "Incident shared",
  datosRefrescados: "Data refreshed",
  Documentacion: "Documentation",
  DocumentacionAdjunta: "Attached documentation",
  DocumentacionAdjuntaDesc: "Documents associated with the incident",
  DocumentacionAdjuntaDesc2: "Documents associated with the notification",
  arrastraArchivos: "Drag and drop your files here to upload them to the folder",
  TextoPropiedadDocumentos:
    "* All documents uploaded to C365 are the property of the community, and will be transferred in case of a change of administrator. If you consider that a document should not be transferred, please indicate it in the 'Modify' option of that document",
  textoConfirmarBorradoCarpeta: "Are you sure you want to delete the folder?",
  textoConfirmarBorradoCarpetaGeneral:
    "Are you sure you want to delete the folder? The folder will be deleted from all communities",
  tituloConfirmarBorradoCarpeta: "Delete folder:",
  textoConfirmarBorradoFichero: "Are you sure you want to delete the file?",
  textoConfirmarBorradoFicheroGeneral:
    "Are you sure you want to delete the file? The file will be deleted from all communities",
  tituloConfirmarBorradoFichero: "Delete file:",
  ExitoBorradoFichero: "File deleted correctly",
  FalloBorradoFichero: "Failed to delete the file",
  Descargar: "Download",
  SeleccionaCompaniaSeguros: "Select Insurance Company",
  PolizaSeguros: "Insurance Policy",
  Direccion_es: "Address/es",
  PorcentajeTotalPropiedad: "Total %",
  TotalReservas: "Total Reservations",
  PorcPropiedad: "Property %",
  ViviendaInquilino: "Home with Tenant",
  ViviendaRepLegal: "Home with Legal Rep.",
  propietario: "Owner",
  inquilino: "Tenant",
  representantelegal: "Legal Representative",
  empresa: "Company",
  ViviendasTipo: "Homes / Type",
  SinViviendas: "Without homes",
  AltaCorrecta: "Unsubscribed correctly.",
  FalloBajaComunidad: "Failed to unsubscribe the community",
  ComunidadNoAlta: "The community is not registered.",
  ErrorGuardadoDatos: "Error saving the data.",
  ErrorDatosExistentes: "The activity ${var1} already exists, please use another name.",
  DatosActualizadosCorrectamente: "Data updated correctly",
  ActividadBorradaCorrectamente: "Activity deleted correctly",
  ActividadExistente: "The activity ${var1} already exists, please use another name.",
  FechaAlta: "Registration date",
  CodigoVecino: "Neighbor Code",
  CodigoPostal: "Postal Code",
  NumeroVecinos: "Number of Neighbors",
  Siniestros: "Claims",
  ModificacionClientes: "Receive Requests",
  ConsultasAdmin: "Receive Queries",
  ConsultasSeguros: "Insurance queries",
  Categoria: "Category",
  Alta: "Registration",
  ConfirmarBajaComunidad:
    "Are you sure you want to unsubscribe the community with id ${var1} from C365?",
  MaximoArchivos: "You can only upload up to a maximum of ${var1} files",
  TipoArchivoNoPermitido: "File type not allowed: ${var1}",
  ArchivoTamañoMaximoSuperado: "The file ${var1} exceeds the maximum allowed size of ${var2} MB",
  ArchivosSubidosCorrectamente: "Files uploaded correctly.",
  NombreCarpetaVacio: "The folder name cannot be empty.",
  MismoNombreArchivoMismoNivel: "You cannot put the same name to a document of the same level",
  CarpetaCreadaCorrectamente: "Folder created correctly.",
  ErrorCrearCarpeta: "Error creating the folder.",
  CarpetaMovidaCorrectamente: "File/Folder moved correctly.",
  ErrorMoverCarpeta: "Error moving the file/folder.",
  ErrorMoverCarpetaNoPermitido:
    "You cannot move the protected folders of Owners' Meetings and General Documentation",
  Carpeta03NoBorrar: "The Owners' Meetings folder cannot be deleted/modified",
  GuardarCambiosModificar: "To save the changes you have to modify the file",
  ErrorCambiarTransferibilidad: "Error changing transferability",
  NombreCambiadoCorrectamente: "Name changed correctly.",
  ErrorCambiarNombre: "Error changing the name.",
  TipoArchivoNoPermitido: "File type not allowed",
  DocumentosComunidad: "Community documents",
  Busqueda: "Search",
  CarpetaActual: "Current folder:",
  NombreCarpeta: "Folder name",
  Descargar: "Download",
  Borrar: "Delete",
  EnviarAviso: "Send notice",
  AvisoDocumentosSubidosC365:
    "All documents uploaded to C365 are the property of the community, and will be transferred in case of a change of administrator. If you consider that a document should not be transferred, please indicate it in the 'Modify' option of that document",
  SeleccionarCarpetaMostrarDetalle: "Select a folder to show its detail",
  TipoArchivoNoPermitido: "File type not allowed: ${var1}",
  TodoOk: "All ok",
  GremioCreadoConecta:
    "The provider has been created by CAFPortal or does not have an associated activity",
  ProveedorBaja: "The provider has been unsubscribed",
  CasoNoCompletado: "uncontemplated case",
  FechaAlta: "Registration Date",
  FechaBaja: "Unsubscribe Date",
  GremioBorradoCorrectamente: "provider deleted correctly",
  Comus: "comus",
  CambioEstado: "Status change",
  NotificacionUsuarioAceptarOCancelar:
    "You can send a notification to the registering user, the administrator and an email to the provider about the update of the incident (IN PROGRESS) or (OPEN) press ACCEPT or CANCEL",
  CambioEstadoIncidencia: "Incident status change",
  CambioEstadoIncidenciaCodigo:
    "The status of the incident with code ${var1} has been changed from ${var2} to ${var3}",
  CambioEstadoIncidenciaCodigoCerrada:
    "The status of the incident with code ${var1} has been closed",
  ArchivoExcedeTamano: "The file exceeds the maximum allowed size of ${var1} MB",
  CambioTipo: "Type change",
  NotificacionIncidenciaAceptarOCancelar:
    "You can send a notification to the registering user, the administrator and an email to the provider about the change of the incident type to CLAIM, press 'ACCEPT' or 'CANCEL'.",
  CambioTipoIncidencia: "Incident type change",
  CambiadoTipoIncidenciaCodigo: "The type of the incident with code has been changed",
  CambiadoTipoAveriaCodigo:
    "You can send a notification to the registering user, the administrator and an email to the provider about the change of the incident type to BREAKDOWN, press 'ACCEPT' or 'CANCEL'.",
  FechaModificacion: "Modification date",
  FechaCreacion: "Creation date",
  NombreRegistrador: "Registrar Name",
  ApellidoRegistrador: "Registrar Last Name",
  RolExiste: "The role ${var1} already exists, please use another one.",
  DatosRefrescados: "Data refreshed",
  RolBorradoCorrectamente: "Role deleted correctly",
  LimpiarBusqueda: "Clear search",
  LimpiarSeleccionado: "Clear selected",
  NoHayRoles: "No roles",
  SeleccionarTodos: "Select all",
  SeleccionarTodosFiltrado: "Select all (filtered)",
  RolSeleccionado: "Role selected...",
  EmailYaExiste: "The Email already exists",
  DNIYaExiste: "The ID already exists",
  NumeroYaExiste: "This number already exists for a meeting in this community",
  TituloYaExiste: "This title already exists for a meeting in this community",
  CompletaCamposObligatiorio: "Please, fill in all the required fields.",
  NoValidoIntroduceCorrecto: "The NIF/NIE is not valid, enter a correct one",
  NoValidoIntroduceCorrecto2: "The NIF/NIE/CIF is not valid, enter a correct one",
  NoValidoIntroduceCorrecto3: "The NIF/CIF is not valid, enter a correct one",
  FotoBorradaCorrectamente: "Photo deleted correctly.",
  FotoGuardadaCorrectamente: "Photo saved correctly.",
  AnadirUsuario: "Add User",
  FechaIncorrecta: "The date is incorrect.",
  NoFechasVacias: "You cannot leave one of the dates empty",
  HorasMinutos: "Hours minutes",
  RegistroHorarioBorrado: "Time record deleted correctly",
  ErrorBorrandoRegistro: "Error deleting record",
  HoraSalidaEntradaIncorrecta: "The exit time cannot be earlier than the entry time",
  TodosRolesSeleccionados: "All roles have been selected.",
  SeleccionarRoles: "Select roles",
  RegistroInquilinoCambiado: "Tenant record changed.",
  ErrorGuardarDatos: "Error saving data",
  UsuarioEliminadoCorrectamente: "User deleted correctly.",
  FalloEliminarUsuario: "There was a failure deleting the user.",
  DNIExisteOtroUsuario: "The ID already exists in another user",
  EmailExisteOtroUsuario: "The Email already exists in another user",
  ContrasenaActualizadaNuevaContrasena: "The password has been updated. New password: ",
  EmailActualizado: "The user name has been updated. New user: ",
  ErrorCambiarContrsena: "Error changing the password.",
  ErrorCambiarEmail: "Error changing the email/user name.",
  ErrorEnviandoEmailConfirmacion: "Error sending the verification email: ",
  EnviadoCorreoConfirmacionA: "The verification email has been sent to ",
  AltaC365: "c365 Registration",
  CodigoCompletisimo: "Complete code",
  VotoBorradoCorrectamente: "Vote deleted correctly",
  TipoVotacion: "Voting type",
  Publicar: "Publish",
  AperturaVotacion: "Opening vote",
  ResultadoPublicado: "Result published",
  PublicadoPorPorciento: "Published by %",
  AltaComunidadConfigurar:
    "You already have this community registered in c365, follow the next steps to configure your community:",
  BienvenidoC365: "Welcome to c365!",
  GeneraCodigoVecinos:
    "Send your neighbors the Community Registration Code or the Neighbor Registration Code so they can register in the app.",
  CompletaDatosProveedoresGestionIncidencias:
    "Complete the data of your contracted providers to manage incidents and claims.",
  MarcarActividades:
    "Mark the activities on which you want your neighbors to be able to pass incidents.",
  CompletaDocumentos: "Upload the documentation you want to share with the owners.",
  IncidenciasYproveedores:
    "If you want the incidents of an activity to go directly to a provider (in addition to the administrator) register the contracts in providers or in activities.",
  SubeDocumentos: "Upload the documentation you want to share with the owners.",
  CreaVotacionesJuntas: "Prepare votes and meetings when necessary.",
  CreaZonasComunes: "Configure the common areas (if you have contracted the Common Areas Pack).",
  HabilitaFichajes:
    "Send your neighbors the Community Registration Code or the Neighbor Registration Code so they can register in the app.",
  SubeDoucmentacionComparte: "Upload the documentation you want and share it with the owners.",
  PreparaVotacionesJuntas: "Prepare votes or meetings when necessary.",
  ConfiguraZonasComunes:
    "Configure the common areas (if you have contracted the Common Areas Pack).",
  HabilitaEmleadosFichar:
    "Enable employees to be able to clock in (if you have contracted the Time Control Pack).",
  MarcarEnviarAviso: "Mark to send notice",
  MarcarEnviarAvisoRegistroVecino: "Mark to send notice or send neighbor registration code",
  UsuariosActivosComunidades: "Active Users / Communities",
  UsuariosComunidad: "Community Users",
  ComunidadesActivasUsuarios: "Active Communities / Users",
  ComusUsuarios: "Comus Users",
  IncidenciasEstados: "Incidents/Statuses",
  EstadoNumero: "Status/Number",
  IncidenciasAverias: "Incidents Breakdowns/Types",
  IncidenciasTodas: "All incidents",
  CodigoDespacho: "Office code",
  Refrescar: "Refresh",
  Volver: "Back",
  AltaDesde: "Registered from",
  AltaHasta: "Registered until",
  NOTIFICACIONES: "NOTIFICATIONS",
  CUADRODEMANDOS: "DASHBOARD",
  TODAS: "ALL",
  ACTIVAS: "ACTIVE",
  TODOS: "ALL",
  ACTIVOS: "ACTIVE",
  ABIERTA: "OPEN",
  ENCURSO: "IN PROGRESS",
  CANCELADA: "CANCELED",
  CERRADA: "CLOSED",
  Desde: "From",
  Hasta: "To",
  hasta: "until",
  bloquearReservaTitutlo: "Reservation blocking",
  CerrarSesion: "Log out",
  ErrorDemasiadosIntentos: "Too many attempts, please wait a while before repeating the action.",
  ErrorCamposRequeridos:
    "The fields highlighted in red are mandatory. To save the changes they must be filled in.",
  ValorAntiguo: "Previous value",
  ValorActual: "Current value",
  Estado: "Status",
  Tipo: "Type",
  Actividad: "Activity",
  Proveedor: "Provider",
  NombreRegistrador: "Registrar",
  NombreResponsable: "Responsible",
  Texto_publicar: "Description",
  Email: "Email",
  Email2: "Email 2",
  Telefono1: "Phone",
  Telefono2: "Phone 2",
  Notas: "Internal notes",
  DerechoDeReservas: "Reservation Right",
  sendRegistrationCodeModaltitle: "Send Registration code",
  sendRegistrationCodeModalConfirm:
    "This action will send the necessary instructions and credentials to register in the app to the user: ",
  sendRegistrationCodesModalConfirm:
    "This action will send the necessary instructions and credentials to register in the app to all selected users who are not registered in the system.",
  sendRegistrationCodeModalSaveMail: "The Email has been modified, save changes and continue?",
  sendRegistrationCodeAllowedTip: "Send Registration Code by mail",
  sendRegistrationCodeDeniedTip: "It is not possible to send without email",
  sendRegistrationCodeSucess: "Email sent correctly.",
  sendRegistrationCodeFailure: "There was a problem sending the email, please try again later.",
  sendRegistrationCodesSucess: "Emails sent correctly.",
  sendRegistrationCodesFailure: "There was a problem sending the emails, please try again later.",
  sendRegistrationCodesMissingMail:
    " does not have an email, enter it in the details or deselect the user before continuing.",
  RazonSocial: "Company name",
  Correo: "Email",
  PersonaDeContacto: "Contact person",
  DatosDespacho: "Office data",
  NombreYapellidos: "Name and Surnames",
  tituloBorradoIncidencia: "Incident ${var1} deleted",
  tituloCompartidoIncidencia: "Incident ${var1} shared",
  mensajeBorradoIncidencia:
    "The incident with code ${var1}. INCIDENT has been deleted, click the link to see the details",
  mensajeCompartidoIncidencia:
    "The incident with code ${var1}. INCIDENT has been shared, click the link to see the details",
  ResultadoPublicadoPorPorciento: "Result published by %",
  ErrorNoArchivoBorrar: "Error, no file has been sent to delete",
  PUBLICADA: "PUBLISHED",
  NOPUBLICADA: "NOT PUBLISHED",
  SINOABS: "YES/NO/ABS",
  OPCIONES: "OPTIONS",
  NuevaOpcionDeVotacion: "New voting option",
  TituloBorrarVotacion: "Delete vote",
  CuerpoBorrarVotacion: "Are you sure you want to delete the vote?",
  AnadirVotacion: "Add vote",
  ElFicheroExisteNoModificar: "The file ${var1} already exists and cannot be modified",
  EnviarCambiosRealizados: "The changes made will be sent to the user/s and administrator",
  CambiarEstadoCerradaNoModificar:
    "Do you want to change the status to CLOSED? if you change it you will no longer be able to modify the incident",
  IncidenciaActualizadaCorrectamente: "The incident has been updated correctly",
  IncidenciaCerradaCambioAdministrador:
    "The incident is closed, if you wish to make any changes contact the administrator, thank you",
  IncidenciaCanceladaCambioAdministrador:
    "The incident is canceled, if you wish to make any changes contact the administrator, thank you",
  IncidenciaNoExiste: "The incident does not exist.",
  BorrarEstadoAbierta: "To be able to delete the status of the incident it must be OPEN",
  ArrastraFicheroCargarloVentana: "Drag the file or click here to load it from the window",
  CargarFicheroAdjuntarFoto: "Click here to upload a file or attach a photo",
  AnadeComentariosEnvialo: "Add comments and send them",
  TextoAnadir: "Text to add",
  NombreZona: "Zone name",
  DescripcionIncidencia: "Incident Description",
  UltimaModificacion: "Last Modification",
  GremioResponsable: "Responsible Provider",
  ImagenAsociada: "Associated image: ",
  Gremio: "provider: ",
  Incidencia: "Incident: ",
  CentrosTrabajo: "Work centers",
  DocumentacionGeneral: "General documentation",
  TodosCorreos: "All emails",
  RecibirIncidencias: "Receive Breakdowns",
  RecibirSiniestros: "Receive Claims",
  RecibirModificacionClientes: "Receive Requests",
  RecibirConsultaAdmin: "Receive Administrator Query",
  RecibirConsultaSeguros: "Receive Insurance Query",
  RecibirConsultas: "Receive Queries",
  CategoriaUsuarioAdministrador: "User-Administrator Category",
  Rol: "Role",
  Fichar: "Clock in",
  ResetearContrasena: "Reset Password",
  VerificarEmail: "Verify email",
  Eliminar: "Delete",
  DetallesUsuario: "User Details",
  FechaUltimoAcceso: "Last Access Date",
  FechaCreacion: "Creation Date",
  AnadirRegistro: "Add Record",
  HorasEntrada: "Entry Hours",
  HorasSalida: "Exit Hours",
  Latitud: "Latitude",
  Longitud: "Longitude",
  Distancia: "Distance",
  VotacionaBorradaCorrectamente: "Vote deleted correctly",
  AnadirCentroDeTrabajo: "Add Work Center",
  CodigoAdministrador: "Administrator Code",
  DatosCentroDeTrabajo: "Work Center Data",
  CentrosTrabajoDespacho: "Work centers of the office",
  CentrosTrabajoComunidad: "Community work centers",
  AvisoActividadSinProveedor:
    "Administrators will always receive incidents by activity, if you want a specific provider to also receive them, associate it from the provider's details.",
  AlertaIncidenciaCompartida: "The incident was already shared. Access the detail to unshare.",
  DocumentoAnadido: "Document added",
  DocumentoEliminado: "Document deleted",
  textoEnviarActualizaciones:
    "Send emails and notifications to those involved notifying them of the changes in the incident",
  tituloEnviarActualizaciones: "Confirm save",
  tip_BorrarZonaComun: "Confirm the delete operation",
  confirmarBorradoZonaComun: "Are you sure you want to delete the common area?",
  ZonaComunBorradaCorrectamente: "Common area deleted correctly",
  tituloConfirmarBorrado: "Confirm deletion",
  UsuariosDespacho: "Office Users",
  zonaPiscina: "Swimming Pool",
  zonaPadel: "Paddle Court",
  zonaTenis: "Tennis Court",
  zonaSalaReuniones: "Meeting Room",
  zonaGimnasio: "Gym",
  zonaOtros: "Others",
  zonaBarbacoa: "Barbecue",
  zonaJardinJuegos: "Garden/Playground",
  zonaFronton: "Fronton",
  zonaSalaInfantil: "Children's room",
  zonaSolarium: "Solarium",
  zonaSpa: "Spa",
  zonaPiscina2: "Swimming Pool II",
  zonaBus: "Bus",
  CentroTrabajoCerradoCorrectamente: "Work center deleted correctly",
  tip_BorrarCentroTrabajo: "Click to delete the work center",
  centroDeTrabajoBorrado: "Work center deleted",
  CuerpoBorrarCentroTrabajo: "To delete the work center press accept.",
  TituloBorrarCentroTrabajo: "Confirm work center deletion",
  Historial: "Reservation history",
  tip_historialReservas: "Click to see the reservation history of the common area",
  HoraInicio: "Start time",
  HoraFin: "End time",
  Administrador: "Administrator",
  Oficial: "Official",
  Auxiliar: "Auxiliary",
  CamposVacios: "The fields in red cannot be empty",
  SeleccionaUnaOpcion: "Select an option",
  AnadirUsuario: "Add User",
  PersonasIncluidas: "People included",
  Enteros: "Integers",
  AnadirZonaComun: "Add common area",
  DetalleZonaComun: "Common area details",
  NombreZona: "Zone name",
  TipoZona: "Zone type",
  NumeroPersonasReserva: "Number of people allowed per reservation",
  NumeroReservasPorDia: "Number of reservations per day/person",
  HorizonteDeFechas: "Date Horizon",
  Aforo: "Capacity",
  SlotsSeguidos: "Consecutive slots allowed per reservation",
  AperturaDiaSiguiente: "Open next day of reservation from:",
  //LimitacionesReserva: "Limitaciones si Reserva Activa",
  LimitacionesReserva: "Allow to reserve if Active Reservation",
  MostrarPortalPiso: "Show Portal, Floor, Letter of the one who reserved",
  NoPermitirReservarSiReserva: "Do not allow to reserve if Active Reservation Not consumed",
  MargenCancelacionReserva: "Reservation cancellation margin",
  NumeroPersonas: "Number of people",
  SeleccionaNumpersonas: "Select the number of people",
  SeleccionaNumreservas: "Select the number of reservations per person/day",
  persona: "person",
  personas: "people",
  reserva: "reservation",
  reservas: "reservations",
  NoAplica: "Does not apply",
  dias: "days",
  dia: "day",
  SeleccionaHorizonte: "Select the number of days",
  SeleccionaSlotsSeguidos: "Select the number",
  Slot: "Slot",
  Slots: "Slots",
  SeleccionaPermitirReservarHora: "Select the time",
  limitaciones1: "NO LIMITATIONS",
  limitaciones2: "Only from the time of application, for the next day",
  limitaciones3:
    "Only on the same day of Active Reservation until the ones of the day are consumed",
  limitaciones4: "You can only reserve with a minimum of hours difference",
  limitaciones5: "Release the next slot after a few hours",
  SeleccionaLimitaSiReserva: "Select the option",
  LimiteHoraCancelacion: "Cancellation time limit",
  Resetear: "Reset",
  ResetearVotacionBody: "Are you sure you want to reset the vote?",
  VotacionResetearCorrectamente: "Vote reset correctly",
  ZonaComunExiste:
    "The common area ${var1} already exists for the current community, please write another name.",
  ControlStockReservas: "Reservation stock control",
  visibleSoloAdmin: "VISIBLE ONLY FOR THE ADMIN",
  limiteReservasUsuario: "Reservation limit/user",
  tipoControlStock: "Stock control type",
  permitirReservarSinStock: "Allow to reserve in the current time without having stock",
  consumirStockReservaActual: "Consume from stock reserving in the current time",
  consumirStockAunCancelando: "Consume from stock even if the reservation is canceled",
  noConsumirStockDiaReserva: "Do not consume stock on the same day of the reservation",
  tipoControlStock1: "Per week",
  tipoControlStock2: "Per month",
  tipoControlStock3: "Per year",
  tipoControlStock4: "Per season",
  tipoControlStock5: "Per days",
  SeleccionaTipoControlStock: "Select the type",
  FechaInicio: "Start date",
  FechaFin: "End date",
  FormaDePago: "Payment method",
  noConsumirDesdeDia: "Do not consume from day",
  noConsumirAPartir: "Do not consume stock from",
  desdedia0: "No day before",
  desdedia1: "day before",
  desdedia2: "days before",
  SeleccionaDiasAntesSinConsumir: "Select the days",
  ControlAbonos: "Fee Control",
  ControlInvitados: "Guest Control",
  AperturaAutomaticaPuerta: "Automatic door opening",
  GestionHorarios: "Schedule management",
  NumInvitadosPorReserva: "Maximum number of guests per reservation",
  NumConvivientesPorReserva:
    "Maximum number of non-nominal cohabitants per area and reservation. This option applies if the user does not have nominal cohabitants",
  minutosApertura: "Activate opening minutes before the reservation time",
  mantenerApertura: "Keep opening after closing minutes after",
  AperturaAutomatica: "Automatic door opening",
  unCuartoDeHora: "1 quarter of an hour",
  mediaHora: "Half an hour",
  tresCuartosHora: "3 quarters of an hour",
  unaHora: "1 hour",
  unaHoraYMedia: "1 and a half hours",
  Horas: "Hours",
  HorasYMedia: "Hours and a half",
  HoraDeApertura: "Opening time",
  HoraDeCierre: "Closing time",
  TamanoSlot: 'Size of the "slot"',
  TodasComunidades: "All communities",
  DireccionPrincipal: "Main address",
  EstablecerHorarioFindes: "Establish schedule for weekends and holidays",
  CalendarioDiasFestivos: "Holiday calendar",
  DireccionRepetida: "The address is already in the system",
  FestivosSeleccionados: "Holidays",
  Enero: "January",
  en: "jan",
  Febrero: "February",
  feb: "feb",
  Marzo: "March",
  mar: "mar",
  Abril: "April",
  abr: "apr",
  Mayo: "May",
  may: "may",
  Junio: "June",
  jun: "jun",
  Julio: "July",
  jul: "jul",
  Agosto: "August",
  ago: "aug",
  Septiembre: "September",
  sep: "sep",
  Octubre: "October",
  oct: "oct",
  Noviembre: "November",
  nov: "nov",
  Diciembre: "December",
  dic: "dec",
  Sabado: "Saturday",
  sab: "sat",
  Domingo: "Sunday",
  dom: "sun",
  Lunes: "Monday",
  lun: "mon",
  Martes: "Tuesday",
  mar: "tue",
  Miercoles: "Wednesday",
  mier: "wed",
  Jueves: "Thursday",
  jue: "thu",
  Viernes: "Friday",
  vie: "fri",
  AnadirHorario: "Add Schedule",
  QuitarHorario: "Remove Schedule",
  HoraApertura: "Opening Time",
  HoraCierre: "Closing Time",
  Sabados: "Saturdays",
  Domingos: "Sundays",
  Festivos: "Holidays",
  AnadirQuitarFestivos: "Add or Remove Holidays",
  Fecha_Publicacion: "Publication date",
  errorValidacionStock1:
    "If you use the reservation stock control, the value of the reservation limit must be at least 1",
  errorValidacionStock2: "start or end date of the stock control season cannot be empty",
  errorValidacionStock3: "start and end date of the stock control season cannot be the same",
  AnadirEmpleado: "Add Employee",
  mensajeErrorHoras: "The closing time cannot be earlier than the Opening time",
  confirmarBorradoProveedor: "Are you sure you want to delete the provider?",
  tituloConfirmarProveedor: "Confirm provider deletion",
  UsuariosCongreso: "CNAF2024 Users",
  Contrasena: "Password",
  Abonos: "Fee Table",
  AbonosLuz: "Light Fee Table",
  ContratosAsoaciados: "Contracts associated with the activity",
  SinContratos: "Without associated contracts or the provider comes from conecta",
  ConContratos: "With associated contracts",
  TipoCobroAbono: "Fee Collection Type",
  TipoCobroAbonoLuz: "Light Fee Collection Type",
  Abonado: "Fee holder",
  CodigoAbono: "Fee Code",
  StockActual: "Current Stock",
  Observaciones: "Observations",
  ReservasDisponiblesPorAbono: "Reservations available by fee",
  CosteEuros: "Cost in euros",
  TablaUsuariosAbono: "Fee Users Table",
  TiposPagos: "Payment Types",
  RecargaAbonoApp: "App fee recharge",
  RecargaAbonoLuz: "Light fee recharge",
  UsuariosAbonoLuz: "Light fee users",
  TiposPagosLuz: "Light Payment Types",
  HoraInicioLuz: "Light start time",
  HoraFinLuz: "Light end time",
  ABIERTO: "OPEN",
  BLOQUEADO: "BLOCKED",
  NoBorrarActividadGremiosAsociados:
    "The activity cannot be deleted because it has associated providers",
  NoBorrarActividadIncidenciasAsociadas:
    "The activity cannot be deleted because it has associated incidents",
  TodoCorrecto: "Everything correct",
  ContratoActividadExpiracion: "The activity contract is about to expire",
  DetectadoProveedorEliminadoDespacho:
    "From c365 we have detected a provider deleted in your office, this provider has been deleted from the activity in which it was associated, it will be associated with the administrator",
  ActividadIncidenciasAbiertas: "The activity has open incident/s associated with the code : ",
  NoGremiosAsociados: "No providers are associated with the activity",
  CentroDeTrabajoCreadoAnteriormente: "That work center has already been created previously",
  Completado: "Completed",
  UsuarioCreadoAnteriormente: "That user has already been created previously",
  AnchoYAltoImagen: "The width of the image must be 1054 pixels and the height 444 pixels",
  NoDatosDisponibles: "No data available",
  ReservasZonasComunes: "Common area reservations",
  GestionReservas: "Reservation management",
  CodigoDebeSerNumero: "The code must be a number",
  ElCodigo: "The code",
  CoincideConOtraComunidad: " matches that of another community",
  VerContratos: "See contracts",
  ExisteEvaluacionNombreCambialo:
    "An evaluation with this name already exists, please change the name to be able to create it",
  PruebaActualizadaCorrectamente: "Test updated correctly",
  TituloEvaluacion: "Evaluation Title",
  CampoObligatorio: "this field is mandatory",
  FechaCreacion: "Creation date",
  SeleccionAreasEvaluacion: "Select the areas that apply the evaluation",
  SeleccionPruebasEvaluacion: "Select the tests for this evaluation",
  FechaInicio: "Start date",
  FechaInicialEvaluacionAntesFinal:
    "The initial date of the evaluation must be before the final date",
  FechaFinEvaluacion: "Evaluation end date",
  CambiarNombreDe: "Change name of",
  AnadirNombreCarpetaFichero: "Add the name you want to give to the file/folder",
  EnvioAvisoPrueba: "test notice sending",
  NombreDeUsuario: "User name",
  SinComunidadAsociada: "Without associated community",
  SinActividadAsociada: "Without associated activity",
  Contratos: "Contracts",
  AnadirContrato: "Add contract",
  seleccionarComu2: "Hidden in all communities",
  DebesSeleccionarComunidadAnadirContrato: "You must select a community to add a contract",
  DebesSeleccionarActividadAnadirContrato: "You must select an activity to add a contract",
  DebesSeleccionarFechaInicioAnadirContrato: "You must select a start date to add a contract",
  YaExisteContratoParaActividadEnComunidad:
    "A contract already exists for this activity in this community",
  YaExisteContratoParaActividadEnComunidad2:
    "A contract already exists for this activity in this community and in the current provider",
  ContratoAnadidoCorrectamente: "Contract added correctly",
  ContratoEliminadoCorrectamente: "Contract deleted correctly",
  Indefinido: "Undefined",
  VerIncidenciasDe: "See incidents of: ",
  DetalleProveedor: "Provider details",
  ErrorBorrarArchivoCarpeta: "Error deleting the file/folder: ",
  DocumentacionDeLaIncidencia: "Incident documentation",
  SinHorasRegistradas: "No registered hours",
  DireccionRepetida: "The address is repeated",
  ValorEnterosNumerico: "The value of integers must be numeric",
  NoDejarEnterosVacios: "You cannot leave the integers empty",
  NoDejarReservasVacias: "You cannot leave the reservation rights empty",
  NoDejarDireccionVacia: "You cannot leave the address empty",
  RegistroRepresentanteCambiado: "Representative record changed.",
  ImagenUsuario: "User image",
  ImagenPorDefecto: "Default image",
  AnadirAlMenosUnaOpcionVotacion: "You must add at least one voting option",
  NoAnadirOpcionRepetida: "You cannot add a repeated option",
  NoAnadirOpcionVacia: "You cannot add an empty option",
  MostrarVotacionesBorradas: "Show deleted votes",
  OcultarVotacionesBorradas: "Hide deleted votes",
  VotacionCerrada: "Vote closed",
  VotacionPublicada: "Vote Published",
  VotacionAbiertaPublicada: "Vote open and published.",
  VerLog: "View log",
  AnadirBono: "Add new bonus",
  TituloBajaAbono: "Delete fee",
  ConfirmarBajaAbono: "Are you sure you want to delete the fee?",
  TituloBajaTipoAbono: "Delete fee type",
  TituloBajaTipoAbonoLuz: "Delete light fee type",
  ConfirmarBajaTipoAbono: "Are you sure you want to delete the fee type?",
  ConfirmarBajaTipoAbonoLuz: "Are you sure you want to delete the light fee type?",
  ProblemaNoPodidoEnviar: "There was a problem and it could not be sent",
  AvisoEnviadoCorrectamenteA: "Notice sent correctly to ",
  destinatarios: " recipients",
  FalloEnviarAviso: "Failed to send the notice: ",
  SoloPuedesSubirUnArchivo: "You can only upload 1 file",
  NoPuedesDejarTipoVacio: "You cannot leave the type empty",
  FalloEnElPago: "PAYMENT FAILED",
  ErrorAbrirNuevaVentanaPermisosVentanas:
    "Error opening the new window, make sure you have permissions to open pop-up windows.",
  ContratoAceptadoPagosIniciados: "Contract Accepted and payments started.",
  ArrastraSueltaArchivosSubirlosCarpeta:
    "Drag and drop your files here to upload them to the folder:",
  AnadirTipoBono: "Add fee type",
  AnadirTipoBonoLuz: "Add light fee type",
  AlertaGuardarCambios:
    "You have made changes in the table, for the changes to be saved click on 'Save'.",
  ProveedorBajaEnComunidades: "The provider has been unsubscribed in the community/ies",
  FInicio: "F. Start",
  FFin: "F. End",
  Contratar: "Contract",
  AceptarTerminosContratacion: "Accept contracting terms",
  VolverPrimerPaso: "Go back to 1st Step",
  DetalleComunidad: "Community Details",
  Juntas: "Meetings",
  MensajeRecargaAbonos:
    "Contact support to provide us with the community data and the IBAN to configure the payment platform",
  MensajeAperturaAutomatica:
    "Contact support to provide us with the community data and the IBAN to configure the payment platform for automatic door opening installation",
  Reservar: "Reserve area",
  BloquearReservas: "Block Common Area",
  seleccionaSlot: "Select the slot/s",
  SeleccionaUsuario: "Select a user",
  comunidadActiva: "Active community",
  comunidadInactiva: "This community is not registered in C365",
  comunidadBloqueada: "Remember that this community is blocked",
  NumeroJunta: "Meeting No.",
  Titulo: "Title",
  confirmarBorradoJunta: "Press accept to delete the meeting",
  AnadirJunta: "Add Meeting",
  FechaCelebracion: "Celebration date",
  tip_BorrarJunta: "Delete meeting",
  NumeroAsistentes: "Number of attendees",
  JuntasComunidad: "Community meetings",
  AbrirConexion: "Open meeting",
  CerrarConexion: "Close meeting",
  Abierta: "Open",
  Cerrada: "Closed",
  VideoComunidad: "Community video conference",
  Entrar: "Enter",
  Junta: "Meeting",
  TextoAyudaActividades1:
    "Select the activities on which you want the neighbors of this community to be able to send incidents.",
  TextoAyudaActividades2:
    "Only the icons of the selected activities will appear on the mobile of the neighbors of this community.",
  TextoAyudaActividades3: "The administrators will receive ALL incidents.",
  TextoAyudaActividades4:
    "If you want a provider to receive the incidents of an activity (in addition to the administrator), associate it from the activity or provider details.",
  JuntaCerradaPestanaCerrandose:
    "The video conference has been closed, the current tab will close in 10 seconds",
  HabilitarQR: "Enable QR",
  irAlEnlace: "Click here to copy the link",
  tip_BorrarUsuarioWeb: "Delete user created from the web",
  tip_BorrarUsuarioConecta: "It is not possible to delete a user imported from the integration",
  cuerpoEliminarUsuario: "Do you want to delete the user",
  tituloEliminarUsuario: "Delete user",
  ActivarUsuarioApp: "Activate the APP for the user",
  TextoActivarUsuarioApp:
    "To activate the user in the APP please, write a password and press accept.",
  EmailVerificado: "Email verified",
  ErrorVerificacionEmail: "Error verifying email",
  ErrorBajaUsuario: "Error unsubscribing the user",
  ProcesoActivacionCompleto: "User activation process completed",
  tituloBajaUsuarioAPP: "Deactivate the user",
  textoBajaUsuarioAPP: "Press accept to unsubscribe the user from the APP",
  ProcesoDesactivacionCompleto: "User deactivation process completed",
  tip_usuarioActivado:
    "User with access to the APP. Press if you want to deactivate the user's access to the APP.",
  tip_usuarioDesactivado:
    "User without access to the APP. Press if you want to activate the user's access to the APP.",
  tip_usuarioSinValidar: "User registered but has not yet validated their email account.",
  amarillo_faltanDatosUsuario:
    "The data [${var1}] is/are missing, please complete the data of the users of this community in your ERP so that CAFPortal can dump them in C365",
  amarillo_usuarioNoRegistrado: "This user is not yet registered in C365",
  amarillo_usuarioViviendaNoAsignada: "This user does not have a home assigned",
  amarillo_usuarioFalloFichaje: "Some exit record is missing in the clockings of the days: ${var1}",
  amarillo_usuarioCamposVacios:
    "The data :[${var1}] is/are missing, please complete the data of the users of this community in your ERP so that CAFPortal can dump them in C365",
  amarillo_usuarioNoValidado: "This user has not validated their email account",
  rojo_usuarioBloqueado: "Remember that this user is blocked",
  verde_usuarioCorrecto: "Correct user",
  tip_publicarJunta: "Publish/Unpublish the meeting",
  confirmarPublicacionJunta: "Press accept to publish this meeting",
  tituloConfirmarPublicacion: "Publish meeting",
  confirmarDespublicacionJunta: "Press accept to unpublish this meeting",
  tituloConfirmarDespublicacion: "Unpublish meeting",
  JuntaPublicadaCorrectamente: "Meeting published correctly",
  errorBorrarIncidencia: "Error publishing the meeting",
  errorAbrirJunta: "Error opening the connection",
  Asistentes: "Attendees",
  asistentes: "attendees",
  activado: "activated",
  desactivado: "deactivated",
  Asistente: "Attendee",
  asistente: "attendee",
  ControlAsistenciaUsuarios: "User attendance control",
  Viviendas: "Homes",
  Vivienda: "Home",
  Conexiones: "No. Connections",
  HoraEntrada: "Last entry",
  HoraSalida: "Last exit",
  TotalDuracion: "Total duration (minutes)",
  confirmarBorradoAsistente: "Are you sure you want to delete the attendee from the meeting?",
  tituloConfirmarBorradoAsistente: "Confirm attendee deletion",
  RolBorradoCorrectamente: "Attendee deleted correctly",
  tip_BorrarAsistente: "Click to delete an attendee",
  TipoAsistencia: "Type of Attendance",
  NoCentroNoFichar: "You cannot clock in if you do not have a work center assigned",
  asistirJunta: "Validate",
  CodigoCopiadoPortapapeles: "Code copied to clipboard",
  ProveedorLocalAnadido:
    "From C365 CAFPortal we have detected a new provider in your office created from the local module. You can check if the data is correct and proceed to associate it with an activity",
  tip_EnvioUsuarios: "Send notice to the previously selected users",
  tip_EnvioCodVec: "Send registration email to the previously selected users",
  NoSoyPropietario: "I am not the owner",
  placeholderObservaciones: "Please indicate the reason for attending this meeting",
  ErrorGuardandoAsistencia: "Error saving attendance",
  AsistenciaRegistradaConExito: "Your attendance has been registered correctly.",
  ReservaCompleta: "Full reservation",
  EmpleadoComunidad: "Community employee",
  JuntaAsociada: "Associated Meeting",
  ErrorFechasContrato: "The start date cannot be greater than the end date",
  ErrorProveedorContrato: "The provider cannot be empty",
  ErrorFechaInicioMayor: "The start date cannot be greater than the end date",
  SinJuntaAsociada: "Without associated meeting",
  EmailNoValidoIntroduceCorrecto: "The Email is not valid, enter a correct one",
  verde_UsuarioRegistrado: "User registered in C365",
  verde_UsuarioNoRegistrado: "User not registered in C365",
  ErrorEmailVacio: "To register the user it is necessary that the user has an email",
  EmailNoValido: "The email is not valid",
  Conexion: "Connection",
  InactivarProveedorConContratos:
    "You cannot deactivate a provider with associated contracts. Please, delete the contracts before deactivating the provider",
  TiempoAcumulado: "Accumulated time",
  QR: "QR Code",
  MostrarQR: "Show QR",
  FormularioAsistencia: "Attendance form for the meeting",
  EnlaceQRNoDisponible: "QR code for the attendance form not enabled.",
  verObservaciones: "View observations",
  ocultarObservaciones: "Hide observations",
  Enviar: "Send",
  tituloFormAvisosJuntas: "Send meeting notice",
  Asociados: "Current contracts",
  AsociadosHistoricos: "Historical contracts",
  BorrarActividadContrato: "Delete contract",
  tituloConfirmarContrato: "Confirm contract deletion",
  confirmarBorradoContrato: "Are you sure you want to delete the contract?",
  ContratosHistoricos: "Historical contracts",
  guardarEnPdf: "Download QR",
  notiArchi: "Notification archived correctly",
  SinUsuarios: "Without users associated with the work center",
  PlantillaConvocatoria: "Download Call",
  PlantillaActa: "Download Resolution Minutes",
  Convocatoria: "Call",
  Acta: "Minutes",
  PrimeraConvocatoria: "First Call Time",
  SegundaConvocatoria: "Second Call Time",
  LugarCelebracion: "Place of celebration",
  ORDINARIA: "Ordinary",
  EXTRAORDINARIA: "Extraordinary",
  ZonaBien: "Common area correctly configured",
  ZonaFestivosMal:
    "The common area has the holiday schedule checkbox marked but does not have any schedule configured",
  ZonaHorariosBloqueados: "The common area has blocked schedules",
  ordenDiaStandar1: "Approval, if applicable, of the annual accounts.",
  ordenDiaStandar2: "Approval, if applicable, of the ordinary budget of expenses and income.",
  ordenDiaStandar3:
    "Relief of positions and appointment of the new Governing Board (President, Vice-president, Members and Administrator)",
  ordenDiaStandar4: "Relief of positions in the governing board",
  ordenDiaStandar5: "Requests and questions",
  ordenDiaStandar1Desc: "",
  ordenDiaStandar2Desc: "",
  Convocante: "Caller",
  juntaCerradaPorApertura:
    "The previously open video conference has been closed to allow the new connection",
  ErrorJuntaNoPublicada: "You cannot open the connection if the meeting is not published",
  Abrir: "Open",
  Descripcion: "Description",
  Junta: "Meeting",
  Nombre: "Name",
  Publicar: "Publish",
  PublicarPorcentaje: "Publish percentage",
  PublicarResultado: "Publish result",
  Roles: "Roles",
  Vacio: "Empty",
  Votode: "VOTE OF",
  hasioeliminao: "HAS BEEN DELETED",
  QRasistencia: "QR attendance",
  CheckboxVotaciones: "Agenda / Votes",
  TooltipVotaciones: "Include votes associated with the call of the meeting",
  LibresDe: "Free of",
  BLOQUEAEDA: "BLOCKED",
  SalaCompleta: "Full room",
  BloquearDesbloquear: "Block/Unblock all day",
  TituloBorrarReserva: "Cancel reservation",
  CuerpoBorrarReserva: "Are you sure you want to cancel the reservation?",
  camposCriticos:
    "The administrator has changed critical data of the common area, the stock of has been recovered",
  camposCriticosSinAbono:
    "The administrator has changed critical data of the common area, your reservation/s have been canceled: ",
  tituloCamposCriticos: "Stock recovery",
  tituloCamposCriticosSinAbono: "Reservation cancellation",
  AlertaNumPersonasAforo:
    "The number of people allowed per reservation cannot be greater than the allowed capacity of the Area: ${var1}",
  labelLimitaciones2: "Application time",
  labelLimitaciones4: "Minimum hours of difference",
  labelLimitaciones5: "Hours until release",
  seleccionaHoraLimitacion: "Select time",
  NoAsistido: "Did not attend",
  AlertaSeCerraraConexion: "By unpublishing the meeting the connection will also be closed.",
  Anulacion: "The reservation has been canceled",
  haCanceladoReserva: "has canceled the reservation",
  ParaElDia: "For the day",
  para: "for",
  verDetalleEnvio: "View sending details",
  seHaReservado: "has been reserved",
  haReservado: "has reserved",
  enNombreDe: "on behalf of",
  reservaZonaComun: "Reservation confirmation",
  adminBloqueoReserva: "The administrator has blocked the reservation",
  delDia: "of the day",
  ContratoActividadExpirado: "The activity contract has expired",
  SinContrato: "Without contract",
  rolEncontradoUsu: "The role of can be deleted because it is assigned to users in the communities",
  rolEncontradoVota:
    "The role of can be deleted because it is assigned to votes in the communities",
  enLasVotaciones: " and to the votes",
  rolEncontradoJuntas:
    "The role of can be deleted because it is assigned to meetings in the communities",
  enLasJuntas: " and to the meetings",
  ningunaDeLasPropuestas: "None of the proposals",
  resultadoEscrutinio: "Scrutiny result",
  Escrutinio1: "⅓ of the votes",
  Escrutinio2: "Simple majority",
  Escrutinio3: "Reinforced majority",
  Escrutinio4: "⅗ parts of the attendees",
  Escrutinio5: "Unanimity",
  tooltipEscrutinio2: "More than half of the votes or more than 50% of the participation share",
  tooltipEscrutinio3:
    "⅗ parts. The votes of the non-attendees are added to the votes of the majority, and they have 1 month to revoke their vote. The minutes cannot be generated until the month has passed",
  NaturalezaVotacion: "Nature of the vote",
  ResultadoVotacion: "Vote result",
  Aprobada: "Approved",
  NoAprobada: "Not approved",
  ConclusionesVotacion: "Voting conclusions",
  Conclusiones: "Voting conclusions",
  configuracionCorrecta: "Correct configuration",
  contratoActivo: "Active contract",
  contratoCaducado: "Expired contract, the provider will continue to receive notices",
  Nombre: "Name",
  Apellido: "Last Name",
  Email: "Email",
  DNI: "NIF/NIE/CIF",
  DNI2: "NIF/CIF",
  Telefono: "Phone",
  BuscarEnTodos: "Search in all fields",
  AnularReserva: "Cancel",
  ErrorCancelarReserva: "A canceled / blocked reservation cannot be canceled",
  DetalleNotificacion: "Notification details",
  DocumentacionNotificacion: "Notification Documentation",
  IrDetalleIncidencia: "View related incident",
  CuerpoBloqueoNotificacion:
    "When deleting the notification, none of the users who have received it will be able to access and view it",
  TituloBloqueoNotificacion: "Confirm notification deletion",
  Leida: "Read",
  FechaLectura: "Read date",
  IdUsuario: "User Id",
  DispositivosEnviados: "Devices sent",
  DispositivosError: "Devices with error",
  marcarNotificacionLeida: "Mark or unmark the notification as read",
  archivarNotificacion: "Archive or unarchive the notification",
  desmarcarNotificacionLeida: 'To unmark the notification as read press "ACCEPT"',
  marcarNotificacionLeida: 'To mark the notification as read press "ACCEPT"',
  tituloNotificacionLeida: "Mark Notification READ/UNREAD",
  recuperarNotificacion: 'To recover the notification press "ACCEPT"',
  archivarNotificacion: 'To archive the notification press "ACCEPT"',
  tituloArchivarNotificaciones: "Archive notifications",
  marcadaLeida: "Marked or unmarked as read",
  marcadaArchivada: "Marked or unmarked as Archived",
  sinNombre: "Without name",
  sinApellido: "Without surnames",
  LEIDA: "READ",
  NOLEIDA: "UNREAD",
  TostaNotificacionArchivada: "The notification has been archived",
  TostaNotificacionDesarchivada: "The notification is no longer archived",
  TostaNotificacionLeida: "The notification has been marked as read",
  TostaNotificacionNoLeida: "The notification has been marked as unread",
  TituloDispositivosUsuario: "User devices table",
  conERROR: " with ERROR",
  TextoNotificacion: "Notification text",
  UrlAdjunta: "Attached url",
  envioDispositivoCorrecto: "The notice has been sent and received correctly on the device",
  envioDispositivoIncorrecto:
    "The notice could not be sent and has not been received on the device",
  errorEnvioNoti: "The notice could not be sent or received on all possible devices (",
  errorEnvioNoti1: "The notice could not be sent or received on",
  errorEnvioNoti2: " devices out of",
  errorEnvioNoti3: " sent",
  exitoEnvioDispositivos: "All devices have received the notice correctly",
  NavegarJunta: "Navigate to the meeting",
  tip_asistirJunta: "Attendance",
  tituloAsistencia: "Attendance details",
  datosAsistencia: "Attendance data",
  //ASISTENCIA_REMOTA_APP: "REMOTA - APP",
  ASISTENCIA_REMOTA_APP_DELEGADO: "REMOTE - APP DELEGATE",
  ASISTENCIA_REMOTA: "REMOTE",
  ASISTENCIA_REMOTA_ENLACE_VIDEO: "REMOTE - VIDEO LINK",
  ENLACE: "LINK",
  APP: "APP",
  ASISTENCIA_FISICA_QR: "PHYSICAL QR",
  ASISTENCIA_FISICA_FORMULARIO: "PHYSICAL FORM",
  ASISTENCIA_FISICA_FORMULARIO_NO_PROPIETARIO: "PHYSICAL FORM + NON-OWNER",
  ASISTENCIA_FISICA: "PHYSICAL",
  ASISTENCIA_DELEGADA: "DELEGATED",
  ASISTENCIA_: " ",
  rojo_usuarioDesactivado: "This user is not yet registered in C365",
  ErrorRecuperandoDatosAsistente: "Error while retrieving attendee data",
  DelegadoEn: "Delegated in",
  usuarioHaVotado: "The user has voted",
  NuevoAsistente: "New attendee",
  NoEstasRegistradoAPP: "You are not registered in the APP",
  usuarioSinVotar: "The user has attended but has not voted",
  ErrorSeleccionOpcionVotacion:
    "You have selected the nature of the vote unanimity but you have not selected any option",
  ErrorSeleccionResultadoVotacion:
    "You have selected the nature of the vote unanimity but you have not selected any result",
  Abs: "Abs",
  JuntaSinConexion: "Meeting without connection",
  AutoRellenarDNI: "Enter your ID to auto-fill your data if you are in the community database",
  UsuarioNoRegistradoEnApp:
    "We have found you in the community database, but you are not registered in the APP. Do you want us to send you an email with the necessary steps so you can register?",
  TipoVotacion: "Voting type",
  QuitarAsistencia:
    "You are going to remove the attendance to the meeting, all the user's votes associated with the meeting will be deleted",
  VerFichajes: "View Clockings",
  PRESIDENTE: "President",
  FIRMANTES: "The undersigned",
  SeleccionaConvocante: "Select caller",
  PrimC: "1st call",
  SegC: "2nd call",
  TipoJunta: "Type of attendance",
  TituloConexion: "Connection title",
  AbrirEnlacePestanaNueva: "Open link in a new tab",
  Paso: "Step",
  OcultarTutorial: "Hide tutorial",
  VerTutorial: "View tutorial",
  Destinatarios: "Recipients",
  Crear: "Create",
  AQuienVaDirigida: "Who is it addressed to?",
  CuandoYDonde: "When and where?",
  TipRolesJuntas: "(By default all owners, select one or more roles)",
  Servicios: "Services",
  ProcesoAltaComunidad: "Community registration process",
  ListaContratos: "List of contracts",
  IrADocumentacion: "Go to the meeting documentation",
  EstadoActual: "Current status",
  Publicada: "Published",
  NoPublicada: "Unpublished",
  NoPublicar: "Unpublish",
  AsistentesConvocados: "Attendees called",
  AsistentesConfirmados: "Attendees confirmed",
  GenerarQR: "Generate QR",
  QRdeLaJunta: "Meeting QR Code",
  TipoConexion: "Connection type",
  DeshabilitarControlAsistencia: "Disable Attendance Control",
  HabilitarControlAsistencia: "Enable Attendance Control",
  Habilitado: "Enabled",
  Deshabilitado: "Disabled",
  TituloVotacion: "Voting title",
  EsParaJunta: "Is it for a Meeting?",
  TipJuntasVotaciones: "If it is for a meeting select one from the list",
  TipoVotacion: "Voting type",
  OpcionesVotacion: "Voting options",
  NingunaDeLasOpciones: "None of the options",
  CriteriosVotacion: "Majority option",
  AbrirVotacion: "Open vote",
  CerrarVotacion: "Close vote",
  VotacionAbierta: "Vote open",
  VotacionCerrada: "Vote closed",
  NoPublicarResultado: "Unpublish result",
  PublicarResultado: "Publish result",
  ResultadoNoPublicado: "Result not published",
  NoPublicarPorcentaje: "Do not show percentage",
  PublicarPorcentaje: "Show percentage",
  PorcentajeNoPublicado: "Showing percentage",
  PorcentajePublicado: "Not showing percentage",
  Votos: "Votes",
  totalVotosActa: "Total votes : ",
  sumaTotalHoras: "Total sum of hours",
  QRfichar: "QR for clocking in",
  enPrep: "in",
  contratoanadir: "Add contract",
  contratoanadira: "Add contract to ",
  OcultarContratosCaducados: "Hide expired contracts",
  MostrarContratosCaducados: "Show expired contracts",
  tituloEnvioAvisoVotacion: "Notice about vote",
  ContratoHisotrico: "Expired contract",
  RegistroDeContratros: "Contracts record",
  OcultarIconosApp: "Display functionalities in the mobile app for this community",
  VerJuntas: "View Meetings",
  Seguro: "Insurance",
  Energia: "Energy",
  Mantenimiento: "Maintenance",
  Reformas: "Reforms",
  VerFacturas: "View invoices",
  VerTutorial: "View tutorial",
  RegistroIncidencias: "Incident record",
  Compartida: "Shared",
  SinCompartir: "Not shared",
  DocumentacionDeLaIncidenciaInfo: "Upload, download or view the incident documentation",
  BotonSOS: "SOS Button",
  NoPublicarIncidencia: "You cannot share an unpublished, closed or canceled incident",
  RegistradoPor: "Registered by",
  NoEliminarOpcionNinguna: "There must be at least one voting option",
  ActividadesTitle: "Activities",
  CiaSegurosComunidad: "Community insurance company",
  ListadoDeActividades: "List of activities",
  DetalleComunidad: "Community details",
  OcultoAPP: "Hidden in the APP",
  VisibleAPP: "Visible in the APP",
  ZonasComunes2: "Reservations",
  PermisosDeAcceso: "Access permissions",
  NIFNIE: "NIF / NIE / CIF",
  DocumentacionInfo: "Download or view the community documentation",
  CentrosTrabajoNavegar: "Navigate to the work centers",
  anadirDirecciones: "Add addresses",
  anadirDireccion: "Add address",
  funcionesNoDisponibles:
    "* Some functionalities will not be available because the user has not registered in the app",
  solicitarConfirmacionEmail: "Request Email Account Confirmation",
  restablecerContrasena: "Reset password",
  seleccionaTipo: "Select the type",
  UsuarioNoCreado: "The user has not been created, please try again",
  cambiarContrasenaUser: "Change user password",
  VerificarEmail: "Verify email",
  EliminarUser: "Delete user",
  verRegistroHorario: "View time record",
  verFichajesUsuario: "View user's clockings",
  EstadoActual: "Current status",
  CentrosAsignadosDetalle: "Assigned work centers",
  planContratadoActivo: "Active contracted plan:",
  actualizarModificarPack: "Update / Modify pack",
  darDeBaja: "Unsubscribe",
  descargarPrecios: "Download prices",
  Plan: "Plan",
  iban: "IBAN",
  numeroIban: "IBAN number",
  Vecinos: "Neighbors",
  Periodicidad: "Periodicity",
  Precio: "Price",
  ViviendasEnComunidad: "Homes in the community",
  EmailVerificado: "Email verified",
  envioConfirmacionEmail: "Send confirmation email",
  AvisosP: "Send notification / email to the user.",
  FicharDesactivado: "Clocking in disabled",
  AsociarUsuariosCentroTrabajo: "Associate users with the work center",
  IncidenciasRecibiraUsuario:
    "From which communities will this administrator user receive incidents",
  AsignalRolPorComunidad: "Assign role by community",
  DocumentacionInfoUsers: "Send confidential documentation to users",
  otorgarPermisosUsuarios: "Grant permissions to users",
  RecibirAverias: "Receive breakdowns",
  // peticion del inmortal
  TipoDeConvocatoria: "Type of Meeting",
  votoDelegado: "Delegated vote",
  Leida: "Read",
  SinLeer: "Unread",
  ErrorSegundaConvocatoria: "The second call cannot be earlier than the first",
  Archivada: "Archived",
  SinArchivar: "Unarchived",
  TelefonoNoValido: "The phone format is not valid, please enter a correct one.",
  ViviendasSolicitadasEnComunidad: "Home requested in the registration in the APP",
  usuarioSinInstancia:
    "The user has registered from the app but does not have an associated instance",
  adjudicarInstancia: "Award instance to the user",
  rechazarAdjudicacion: "Reject instance award",
  adjudicacionRechazadaExito: "Request rejected",
  adjudicacionRechazadaFallo: "Failed to reject the request",
  confirmarRechazarAdjudicacion: "Do you want to reject the instance award request?",
  viviendaSolicitada: "Requested in APP registration",
  ResultadoEnviosNotificaciones: "Result of notification deliveries",
  usuarioNoEncontradoEnComunidad:
    "User not found in the community database, if you are not an owner check the box 'I am not an owner'",
  JuntaYaBorrada: "The meeting has already been deleted",
  VisualizarAPP: "View Icons",
  VerIconosAPP: "View / Hide icons in the APP",
  VisualizarAPPIconos: "Display functionalities in the mobile app for this community",
  JuntaYaBorradaQR: "The meeting has already been deleted, the QR cannot be generated",
  JuntaYaBorradaPublicar: "The meeting has already been deleted, it cannot be published",
  ConfigurarProveedores:
    "Complete the data of your contracted providers, to manage breakdowns and claims.",
  CrearCentrosTrabajo:
    "Enable employees to be able to clock in (if you have contracted the Time Control Pack).",
  ConfigurarProveedores2: "Providers configuration",
  MarcarActividades2: "Mark activities",
  AsociarProveedorAactividad: "Associate provider with activity",
  SubirDocumentos: "Upload documents",
  CrearJuntasYvotaciones: "Create meetings and votes",
  AnadirZonasComunes: "Add common areas",
  CrearCentrosDeTrabajo: "Create work centers",
  RegistroDeUsuarios: "User registration",
  CrearZonas: "Create common areas",
  MostrarEnlace: "Show link",
  OcultarEnlace: "Hide link",
  CrearJuntas: "Create meetings",
  CrearVotaciones: "Create votes",
  AnadirZonasComunes2: "Create work centers",
  Totales: "Totals",
  VotoGuardadoCorrectamente: "Vote saved correctly",
  AnadirVotoModificar: "Add / Modify vote",
  SeleccionaUsuarioVotar: "Select a user to vote",
  SeleccionaOpcionVotar: "Select a voting option",
  ErrorAdjudicandoInstancia: "An error occurred while awarding the instance.",
  CodigoAdministracionEnUso: "The administration code is already in use",
  CodigoAdminitradorNoValido: "The value must contain exactly three letters followed by a number.",
  usuarioConInstanciaSinAdjudicar: "The user has an instance without being awarded",
  BloquearZona: "Block zone",
  errorBorrarIncidencia2: "Only incidents with the status CLOSED or CANCELED can be deleted",
  ReservaCanceladaCorrectamente: "The reservation has been canceled correctly",
  Contacto: "Contact person",
  enviadoscorrectosCabecera: "Notifications sent correctly",
  enviadosIncorrectosCabecera: "Notifications sent with error",
  enviadosTotalesCabecera: "Notifications sent",
  enviadoTotalesCabeceraTexto: "Total notifications sent",
  Calle: "Street",
  ReferenciaExt: "Reference",
  CNAEDescripcion: "CNAE Description",
  DatosContratoGuardadosCorrectamente: "Contract data saved correctly",
  Propiedades: "Properties",
  PropietariosVecinos: "Owners/Tenants/Companies/Legal Reps.",
  DestinatarioConsulta: "Query recipient",
  SlotReservadoDesbloquealo:
    "The slot is blocked. If you want to reserve it, you must first unblock it.",
  CreadoDesde: "Created from",
  ProveedorRecibiraEmail: "* The provider always receives an email with changes in the incident",
  EnviarNotificaciones: "Send notifications",
  enviarEmails: "Send emails",
  ResetearBusqueda: "Reset search",
  Recibos: "Receipts",
  RecibosDetalle: "View receipts",
  pagador: "Payer",
  cobrador: "Collector",
  nif_cobrador: "Collector NIF",
  nif_pagador: "Payer NIF",
  importe: "Amount",
  fechaVencimiento: "Due date",
  comentario: "Comment",
  totalEnterosActa: "Total integers: ",
  Pagado: "Paid",
  pdtPago: "Pending payment",
  totalPagado: "Total paid",
  RegistroDeAccesos: "Access Record",
  AbrirConexionReunion: "Meeting connection",
  ErrorJuntaBorrada: "You cannot open the connection if the meeting has already been deleted",
  tooltip_emulador: "Simulation for viewing by community neighbors only",
  emulador: "APP visualization for neighbors",
  GenerarQR: "Generate QR",
  RegistroHorarioDe: "Time record of the user:",
  Mes: "Month:",
  Semana: "Week:",
  ArrastrarImagen: "Drag or drop the image here",
  SeleccionaOpcion: "Select an option",
  MostrarArchivadas: "Show archived",
  FiltrarUsuariosAvisos: "Filter users for sending notices",
  ContratoActual: "Current contract",
  ListaContratosHistoricos: "List of historical contracts",
  ResolucionNecesaria: "* Recommended resolution 1054px 444px",
  QueIncidenciasRecibira: "What incidents will this administrator user receive?",
  seleccionaPlanNecesidades: "Select the plan that best suits your needs",
  Precios: "Prices",
  PackContratadoActual: "Current contracted pack",
  SeleccionaFormaPago: "Select the payment method",
  PagoMensual: "Monthly Payment",
  HasSeleccionadoPlan: "You have selected the plan",
  ConFormaPago: "with the payment method",
  PagoAnual: "Annual Payment",
  ElPRecioTotal: "The total price is",
  al: "at",
  Siguiente: "Next",
  SeleccionaOpcionFacturacion: "Select a billing option",
  IBANComunidad: "Community IBAN",
  IBANAdministrador: "Administrator IBAN",
  conLa: "with the",
  IBANElegido: "and the chosen IBAN is",
  cuentaBancariaEs: "and the bank account is",
  ResumenServicios: "Summary of Contracted Services",
  DetalleServicios: "Below, a summary of the contracted services is detailed",
  PlanSeleccionado: "Selected plan",
  IbanAsociado: "Associated IBAN",
  PrecioTotal: "Total price",
  SiDeseasModificar:
    "If you wish to make modifications, you can go back in the contracting process and return to the corresponding step.",
  Atentamente: "Sincerely",
  Empresa: "C365",
  PasoFinal: "Final step",
  ResumenDeLosDatosContratados: "Summary of the contracted data",
  DescargarContrato: "Download contract",
  DireccionCompleta: "Full Address",
  AlertaTitulo: "ALERT! Important changes in the nature of the vote",
  Mensaje1: "By selecting the nature of the vote",
  Mensaje2: "and the option",
  Mensaje3: "The vote will be assigned",
  Mensaje4: "to all voters at the time of",
  ResultadoEnvio: "Sending result",
  TokenDispositivo: "Device token",
  ErrorTipo: "Error type",
  DetalleMensajeError: "Error message detail",
  PrimeraVezPago: "It is the first time you make a payment charged to the",
  ConEstaCuenta: "with this account: ",
  PulsaConfirmarPago:
    "Press confirm to charge the payment to this purchase and the following ones.",
  ConfirmarIban: "Confirm the IBAN:",
  Confirmar: "Confirm",
  Volver: "Go back",
  VolverPrimerPaso: "Go back to 1st step",
  MostrarVotosBorradas: "Show deleted votes",
  OcultarVotosBorradas: "Hide deleted votes",
  ElAdminHaBorradoVotacion: "The administrator has deleted the vote",
  NoBorrarActividadConContratos: "An activity with associated contracts cannot be deleted",
  HazClicAquiParaAcceder: "Click here to access",
  CifRepetido: "The CIF is already in use in another provider",
  SuperAdministrador: "Super Administrator",
  DeshacerCambios: "Undo changes",
  Entendido: "Understood",
  comunidadIbanDiferente: "The current IBAN differs from the one in the current contract.",
  NoTienesAcceso: "You do not have access to this functionality, redirecting to the main page",
  MostrarDatosAdminToast: "The data of the administrator's office will be shown",
  NoMostrarDatosAdminToast: "The data of the administrator's office will not be shown",
  MostrarDatosDespacho: "Show office data",
  MostrarRecibosComunidades: "Show future receipts of the community",
  MarcarFuturosRecibosComunidad: "Mark future receipts of the community",
  MarcarFuturosRecibosUsuarios: "Mark future receipts of the users",
  Mostrar: "Show",
  NoMostrar: "Do not show",
  RecibosComunidad: "Community receipts",
  RecibosUsuarios: "User receipts",
  VerEnLaAPP: "View in the APP",
  PublicarFuturosRecibos: "Publish future receipts",
  Publicados: "Published",
  SinPublicar: "Unpublished",
  usuarioVotoBorrado: "The vote is deleted",
  ContratoGuardadoCorrectamente: "Contract saved correctly",
  ArchivoBorradoCorrectamente: "File deleted correctly",
  yaExisteEnOtroDespacho:
    "The community already exists and is registered in another office, to be able to continue it will have to be previously unsubscribed from the other office.",
  FechaUltimoAcesso: "Last access date",
  rojo_usuarioBloqueado: "This user is blocked",
  ReferenciaExterna: "External reference",
  titloCambiarEstadoVotacion: "Change voting status of",
  estasSeguroCambiarEstado: "Are you sure you want to change the voting status?",
  VotacionEstadoModificado: "The voting status has been modified correctly",
  FechaUltimoAcceso: "Last access date",
  ReservasNoValidas: "The reservation right is not valid, it must be 0 or 1",
  pendienteValidarEmail: "This user has already registered, is pending to validate their email.",
  ErrorUsuarioNoCreado: "You cannot block / unblock a user who is not registered",
  EmailRequerido: "The email is required to verify the email",
  todosCentroDeTrabajoSeleccionados: "All users of the work center have been selected",
  LimpiarBusqueda: "Clear search",
  limpiarSeleccionados: "Clear selected",
  seleccionarTodos: "Select all",
  seleccionarTodosFiltrado: "Select all (filtered)",
  todasLasComunidadesHanSidoSeleccionadas: "All communities have been selected",
  noHayCentroDeTrabajo: "No work centers",
  centrosDeTrabajo: "Work centers",
  noHayComunidades: "No communities",
  todasComunidadesPorDefecto: "All communities by default",
  todosLosRolesHanSidoSeleccionados: "All roles have been selected",
  noHayRoles: "No roles",
  seleccionarRoles: "Select roles",
  EmailIntegracion: "Integration email",
  AltaCorrectaDemo: "Correct registration in the demo",
  CodigoIncorrectoDemo: "The code entered is not correct",
  IntroduceCodigoGratiws: "Enter the code to register in C365",
  avisoBajaVecinosTitulo: "UNSUBSCRIBE NOTICE",
  avisoBajaAdministradorTitulo: "UNSUBSCRIBE NOTICE",
  avisoBajaVecinos:
    "Your administrator has unsubscribed the c365 app of your community, from this moment on you will only be able to view the notifications in the app, until your community reactivates the services.",
  avisoBajaAdministrador:
    "We have received the request to unsubscribe from the c365 platform, from this moment on it is inactive on the platform",
  conservarDatos1:
    "This community was already registered in c365, do you want to recover all the data of that community?",
  conservarDatos2:
    "If you do not keep the previous configuration, keep in mind that all users will have to register in the app again. If even so, you do not want to keep the data press “Do Not Keep”, otherwise “Keep Data”",
  ValidadoEnOtraComu: "The user is validated but is NOT registered in this community",
  idErp: "Erp Id",
  tokenTitulo: "The session is about to expire",
  tokenCuerpo: "Do you want to renew the session?",
  ErrorVerificandoEmail: "Error verifying the email",
  ordenActualizado: "Order updated correctly",
  detectedComu:
    "This community was already registered in c365, do you want to recover all the data of that community?",
  RecoverOldData: "Recover all data",
  VisualizarAPPIconosDespacho: "Display functionalities in the mobile app for all communities",
  Sos: "SOS",
  Seguros: "Insurance",
  todoVisible: "Visible in all communities",
  DNIYaExisteEnLaComu: "The ID already exists in this office, please enter another one",
  ArrastrarSoltarImagen: "Drag or drop the image here",
  altaOtroDesk: "The user is already registered in the office",
  enLasComus: " and in the communities: ",
  RedimensionarImagen: "The image has been resized correctly to 1054px x 444px",
  comunidadFalta: "The field is missing: ",
  comunidadFaltaImportante: "The assignment of is missing ",
  comunidadFaltaImportante2: " fill it in in activities",
  DNIotracomunidad: "We have detected a user with the same ID in another community",
  anadirloComunidad: "Do you want to add it to this community?",
  votacionBorrada2: "You cannot modify a deleted vote",
  Responsable: "Responsible",
  SeleccionaResponsable: "Select a responsible",
  ApellidoResponsable: "Responsible Last Name",
  SuscripcionDespacho: "CAFcomunidad License",
  DetallesLicencia: "View / deactivate license",
  procesoActivacionComunidad: "Community activation process",
  ResumenDeLaContratacion: "Summary of the contract",
  DespachoSinIBAN:
    "This office does not have an associated IBAN, to correct this problem close this tab, add the IBAN to the office in CAFportal and enter CAFcomunidad again",
  ConfirmaDatosYAceptaContinuar: "Confirm the data and accept the conditions to continue",
  ContratarActivar: "By contracting CAFComunidad for the office you will activate a",
  SuscripcionMensualDe: "monthly subscription of",
  RecibosIBANDespacho: "The receipts will be passed to the office's IBAN",
  DespachoSinIBAN:
    "This office does not have an IBAN and the contracting process cannot be completed. Please add it from CAFportal.",
  DespachoNoActivado: "Your office has not yet been activated in CAFcomunidad!",
  ActivarSuscripcionParaUsar:
    "To be able to use CafComunidad you will first have to activate the subscription. Meanwhile you can try the application with the test community you have available.",
  ContratarCAFComunidad: "Contract CAFcomunidad",
  ContratarCafComunidadEsteDespacho: "Contract CAFcomunidad for this office",
  ErrorAbrirNuevaVentana:
    "Error opening the new window, make sure you have permissions to open pop-up windows.",
  ComunidadActivadaCorrectamente: "The community has been activated correctly",
  DeseasActivarComunidad: "Do you want to Activate the community?",
  DeseasIniciarPagosComunidad: "Do you want to Start Payments of the community?",
  PrecioComunidad: "The price of the community",
  Con: "with",
  VecinosEsDe: "neighbors is",
  AlMes: "per month",
  NumeroCuentaBancaria: "The bank account number is",
  ComunidadNoIBAN: "The community does not have an IBAN, please, access CAF portal and add it",
  ExitoCambioLenguaje: "Se ha cambiado al idioma: ",
  CambiarIdioma: "Change Language",
  ConfirmarCambiarIdioma: "If you change the language you may lose the changes you were working on",
  agendarImportacionTitulo: "Schedule data import",
  agendarImportacionDescripcion: "Click here to book an appointment to import your data",
  //Ultima revision 04-09
};
/*
export const diccionario_en = new Proxy(diccionario_en_base, {
  get(target, prop) {
    // If prop is a Symbol (like Symbol.toStringTag), return the default behavior
    if (typeof prop === "symbol") {
      return Reflect.get(target, prop);
    }

    // Otherwise, return the translated value or the fallback
    return prop in target ? target[prop] : `${String(prop)} [sin trad.]`;
  }
});
*/

export const tableLocation_en = {
  pagination: {
    labelRowsSelect: "Rows per page",
    labelDisplayedRows: "{from}-{to} of {count}",
    firstAriaLabel: "First page",
    firstTooltip: "First page",
    previousAriaLabel: "Previous page",
    previousTooltip: "Previous page",
    nextAriaLabel: "Next page",
    nextTooltip: "Next page",
    lastAriaLabel: "Last page",
    lastTooltip: "Last page",
  },
  toolbar: {
    searchTooltip: "Search",
    searchPlaceholder: "Search",
    nRowsSelected: "{0} row(s) selected",
  },
  header: {
    actions: "Actions",
  },
  body: {
    emptyDataSourceMessage: "No data available",
    filterRow: {
      filterTooltip: "Filter",
    },
    editRow: {
      saveTooltip: "Save",
      cancelTooltip: "Cancel",
      deleteText: "Are you sure you want to delete this row?",
    },
    addTooltip: "Add row",
    deleteTooltip: "Delete row",
  },
  edit: {
    saveTooltip: "Save",
    cancelTooltip: "Cancel",
    deleteText: "Are you sure you want to delete this row?",
  },
  group: {
    deleteTooltip: "Delete group",
    editTooltip: "Edit group",
    addTooltip: "Add group",
  },
};
